import React from 'react'
import './HomePageFilter.css'
const HomePageFilter = () => {
  return (
    <div className="filter">
        <button>Filter</button>
        <button>Fast Delivery</button>
        <button>Ratings 4.0+</button>
        <button>Pure Veg</button>
        <button>Offers</button>
        <button>Rs.300-Rs.600</button>
        <button>Less then Rs.300</button>
      </div>
  )
}

export default HomePageFilter
